import { useStateOfNestedSelectFilter } from '@/hooks/useStateOfNestedSelectFilter';
import { useState } from 'react';
import { useService } from '@/contexts/ServiceContext';
import _get from 'lodash/get';
import { FLIGHT_LEG_TYPE_MAP } from '@tajawal/web-flights-sdk/lib/constants/filters.constants';
import TimeFilterStore from '@tajawal/web-flights-sdk/lib/stores/filter/time-filter.store';

function useTimeFilter(filter: TimeFilterStore) {
  const { state, toggle, isDirty, reset } = useStateOfNestedSelectFilter(filter);

  const [activeIndex, setActiveIndex] = useState(0);
  const { resources } = useService();
  const originFilterState = _get(state, `${activeIndex}.${FLIGHT_LEG_TYPE_MAP.ORIGIN}`, []);
  const destinationFilterState = _get(state, `${activeIndex}.${FLIGHT_LEG_TYPE_MAP.DESTINATION}`, []);

  function handleReset() {
    reset(true);
  }

  function handleToggleOption({ index, type, code }) {
    toggle({ index, type, code }, true);
  }

  return {
    state,
    activeIndex,
    originFilterState,
    destinationFilterState,
    isDirty,
    handleReset,
    handleToggleOption,
    setActiveIndex,
    resources,
  };
}

export default useTimeFilter;
